// store.js
import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction, firebaseAction } from 'vuexfire'
import { db, fb } from './firebase'


export const dbSchema = {
  bulkTypes: "bulktypez",
  requests: "requestz",
  users: "uzers",
  settings: 'bulksettingz',
  settingsDocId: 'Z31YwQmwVmvsRKWsCUrx'
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bulksettings: [],
    user: { 
        loggedIn: false,
        data: null
    },
    myRequests: [],
    allRequests: [],
    selectedRequests: 0,
    bulkTypes: []
  },
  getters: {
    user(state){
      return state.user
    },
    selectedRequests(state) {
      return state.selectedRequests
    }
  },
  mutations: {
      SET_USER(state, data) {
        state.user = data;
      },
      SET_REQUESTS(state, data) {
        state.selectedRequests = data
      },
      ...vuexfireMutations
  },
  actions: {
    loadAllRequests: firestoreAction(({ bindFirestoreRef }) => {
      // return the promise returned by `bindFirestoreRef`
      return bindFirestoreRef('allRequests', db.collectionGroup(dbSchema.requests))
    }),
    loadMyRequests: firestoreAction(({ bindFirestoreRef }, user) => {
      return bindFirestoreRef('myRequests',  db.collection(dbSchema.users).doc(user.id).collection(dbSchema.requests))
    }),
    loadBulksettings: firestoreAction(async ({ bindFirestoreRef }) => {
      return bindFirestoreRef('bulksettings', db.collection(dbSchema.settings).doc(dbSchema.settingsDocId))
    }),
    loadBulkTypes: firestoreAction(async ({ bindFirestoreRef }) => {
      return bindFirestoreRef('bulkTypes', db.collection(dbSchema.bulkTypes))
    }),
    setSelectedRequests({ commit }, rows) {
      const objString = JSON.stringify(rows)
      const obj = JSON.parse(objString)
        commit("SET_REQUESTS", obj);
    },
    fetchUser({ commit }, user) {
        var isLoggedIn = user !== null;
        if (user) {
            var userData = {};
            db.collection(dbSchema.users)
            .where("email", "==", user.email)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(function (doc) {
                  userData = doc.data();
                });
            }).finally(() => {
              const { admin, manager, ...accountData } = userData
              var userObject = {
                email: user.email,
                name: user.displayName,
                phone: user.phoneNumber,
                id: user.uid,
                isAdmin: admin,
                isManager: manager,
                isLoggedIn,
                ...accountData
              }
                commit("SET_USER", userObject);
                  this.dispatch('loadMyRequests', userObject)
                  if(userObject.isAdmin)
                      this.dispatch("loadAllRequests");
            })

        } else {
          commit("SET_USER", {isLoggedIn});
        }
      }
  },
})